import { Flex } from 'foundations-components/components/Flex';
import { HR } from 'foundations-components/transitional/components/HR';
import { getAgentId, getAgentState, getAvatarUrl, getBotId, getEmail, getFirstName, getIsAssignable, getLastName } from '../operators/assignees';
import ResponderOption from './ResponderOption';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UserOption = ({
  currentAssigneeId,
  currentUserId,
  capacityCategory,
  option
}) => {
  if (!option || !option.responder) {
    return null;
  }
  const {
    responder
  } = option;
  const user = /*#__PURE__*/_jsx(ResponderOption, {
    agentId: getAgentId(responder) || getBotId(responder),
    agentState: getAgentState(responder),
    avatar: getAvatarUrl(responder),
    currentAssigneeId: currentAssigneeId,
    email: getEmail(responder),
    firstName: getFirstName(responder),
    capacityCategory: capacityCategory,
    isAssignable: getIsAssignable(responder),
    lastName: getLastName(responder),
    responder: responder
  });
  if (currentUserId === option.value) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [user, /*#__PURE__*/_jsx(HR, {
        marginBlockEnd: "250",
        marginBlockStart: "0"
      })]
    });
  }
  return /*#__PURE__*/_jsx(Flex, {
    marginInlineStart: "-500",
    children: user
  });
};
UserOption.displayName = 'UserOption';
export default UserOption;